import { db } from '../config/firebase';
import { collection, doc, getDocs, query, updateDoc, where } from 'firebase/firestore';

const COLLECTION = 'clientes';

/**
 * Guarda los datos fiscales en el padrón de clientes para que se autocompleten la
 * próxima vez que se cargue una orden de ese comitente.
 *
 * Viven en el cliente y no en la orden porque son datos del comitente que se
 * reutilizan entre licitaciones. El CUIT se persiste normalizado
 * (XX-XXXXXXXX-X) y el tipo de documento con el valor que espera el sistema
 * externo (CUIT / FCICNV / CCN).
 *
 * @param {string} nroComitente
 * @param {{ cuit?: string, tipoDocumento?: string }} datos - ya formateados por el llamador
 * @returns {Promise<boolean>} false si no se encontró el cliente o no había nada que guardar
 */
export const saveDatosFiscalesCliente = async (nroComitente, { cuit, tipoDocumento } = {}) => {
  try {
    const cambios = {};
    if (cuit) cambios.cuit = cuit;
    if (tipoDocumento) cambios.tipoDocumento = tipoDocumento;
    if (Object.keys(cambios).length === 0) return false;

    const snapshot = await getDocs(
      query(collection(db, COLLECTION), where('nroComitente', '==', nroComitente))
    );
    const clienteDoc = snapshot.docs[0];
    if (!clienteDoc) return false;
    await updateDoc(doc(db, COLLECTION, clienteDoc.id), cambios);
    return true;
  } catch (error) {
    console.error('clientesService.saveDatosFiscalesCliente failed:', { nroComitente, error });
    throw error;
  }
};
